import React from 'react';
import Link from '@mui/material/Link';
import loginimage from "../../assets/visibility.png";
import download from "../../assets/download.png";
import { Typography } from "@mui/material";
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';


import {
  TextField,
  Grid,

  InputAdornment,
  Icon,
} from "@mui/material";




const National = (props) => {
  const{heading,Subheading,ID}=props
  let value =  localStorage.getItem("openvalue");
  return (

    <Grid style={{ padding:'10px',background: '#FCFCFC', marginTop: '12px', border: "1px solid #E3E3E3", boxShadow: '0px 3px 6px #A7A7A729', width: '100%', borderRadius: "6px" }}>
   

      <Typography
        style={{
          fontWeight: '600',
          letterSpacing:'0.1px',
          fontFamily: 'Rubik',
          
          color: "#000000",
          marginLeft: '15px'
        }}
      >
        {heading}
      </Typography>
      <Grid
        style={{
          display: "flex",
          alignItems:'center',
        }}
      >
        <div style={{width:'55%'}}>
        <Typography

style={{

  fontFamily: 'Rubik',
  fontWeight: 'normal',
  color: "#000000",
  marginLeft:'15px'

}}
>
{Subheading}  &nbsp; {ID} 
</Typography>
        </div>
      
    

        <Typography
          style={{
            fontFamily: 'Rubik',
            fontWeight: 'normal',
            color: "#000000",
            marginLeft:'1%'
          
          }}
        >
          Attached file
        </Typography>
        <Grid style={{marginLeft:'2%'}}>
        <Link style={{ color: '#214E57', textDecoration: 'none', borderBottom:"1px solid #214E57", fontFamily: 'Rubik', }} href="#">ID proof 1.pdf</Link>
        </Grid>
        <Grid sx={{ display: 'flex', marginLeft:'auto'}}>
          {/* <img  src={loginimage} alt="visibility" /> */}
          <VisibilityOutlinedIcon style={{color:'#0D5C75'}}/>
          <FileDownloadOutlinedIcon sx={{ marginLeft:'20px',marginRight:'20px',color:'#0D5C75' }}/>
          {/* <img style={{ marginLeft:'20px',marginRight:'20px' }} src={download} alt="download" /> */}
        </Grid>

      </Grid>
    </Grid>

  )
}

export default National;